// c:/xampp/htdocs/miners-market-main/components/forms/RefurbishingForm.js

import AccordionSection from '../AccordionSection.jsx';
import MediaManager from './MediaManager.jsx';

function RefurbishingForm({ formData, onFormChange, openSection, onToggleSection }) {
    return (
        <div className="space-y-2">
            <AccordionSection title="1. Service Details" id="serviceDetails" openSection={openSection} onToggle={onToggleSection}>
                <div>
                    <label className="block text-sm font-medium text-gray-700">Service Offered*</label>
                    <input type="text" name="service_name" value={formData.service_name || ''} onChange={onFormChange} required className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" placeholder="e.g., Excavator Bucket Refurbishing" />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700">Service Description</label>
                    <textarea 
                        name="service_description" 
                        value={formData.service_description || ''} 
                        onChange={onFormChange} 
                        rows="3" 
                        className="mt-1 block w-full border-gray-300 rounded-md shadow-sm"
                    ></textarea>
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700">Rate (R/hour)*</label>
                    <input type="text" name="rate_per_hour" value={formData.rate_per_hour ?? ''} onChange={onFormChange} required className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                </div>
                <div className="flex items-center">
                    <input
                        id="is_price_on_request"
                        name="is_price_on_request"
                        type="checkbox"
                        checked={!!formData.is_price_on_request}
                        onChange={onFormChange}
                        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                    />
                    <div className="ml-3">
                        <label htmlFor="is_price_on_request" className="font-medium text-gray-700">Set Price on Request</label>
                        <p className="text-gray-500 text-sm">Price will not be publicly shown. It will only be revealed to verified buyers who go through the Price on Request process.</p>
                    </div>
                </div>
            </AccordionSection>

            <AccordionSection title="2. Images" id="images" openSection={openSection} onToggle={onToggleSection}>
                <MediaManager formData={formData} onFormChange={onFormChange} />
            </AccordionSection>

            <AccordionSection title="3. Contact Information" id="contactInfo" openSection={openSection} onToggle={onToggleSection}>
                <div className="grid md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Sales Contact Name</label>
                        <input type="text" name="sales_contact_name" value={formData.sales_contact_name || ''} onChange={onFormChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Sales Contact Phone</label>
                        <input type="tel" name="sales_contact_phone" value={formData.sales_contact_phone || ''} onChange={onFormChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                    </div>
                </div>
                <div className="grid md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Sales Contact Email</label>
                        <input type="email" name="sales_contact_email" value={formData.sales_contact_email || ''} onChange={onFormChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Company Name & Address</label>
                        <input type="text" name="company_name_address" value={formData.company_name_address || ''} onChange={onFormChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                    </div>
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700">Support Contact Details</label>
                    <textarea name="support_contact_details" value={formData.support_contact_details || ''} onChange={onFormChange} rows="3" className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" placeholder="e.g., Technical support line, email, or website"></textarea>
                </div>
            </AccordionSection>
        </div>
    );
}

export default RefurbishingForm;
